module.exports = __webpack_public_path__ + "static/img/54.2e5ed656.png";